/**
 * PC 예약 캘린더 모듈
 * 캘린더 상호작용, 날짜 선택, 예약 데이터 관리
 */

(function () {
  'use strict';

  // ========================================
  // 상수 정의
  // ========================================
  var TOTAL_TIME_SLOTS = 9; // 09:00 ~ 17:00
  var TIME_SLOTS = ['09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00'];
  var DAY_NAMES = ['일', '월', '화', '수', '목', '금', '토'];
  var ONE_DAY_MS = 86400000; // 1일 = 86400000ms

  // ========================================
  // 전역 상태
  // ========================================
  var calendarInstance = null;
  var reservationData = [];
  var selectedDates = []; // 월 변경 시에도 유지되는 선택된 날짜 목록
  var reservedSlots = {}; // 사용자가 예약한 슬롯 { date: { pc: [times] } }
  var isLoading = false; // 로딩 상태 추적
  var options = {};
  // ========================================
  // 초기화
  // ========================================

  /**
   * 캘린더 초기화
   */
  function initCalendar(elementId, opts) {
    var calendarEl = document.getElementById(elementId);
    if (!calendarEl) {
      console.error('Calendar element not found:', elementId);
      return;
    }
    options = opts || {};

    calendarInstance = new FullCalendar.Calendar(calendarEl, {
      initialView: 'dayGridMonth',
      contentHeight: 'auto',
      fixedWeekCount: false,
      dateClick: handleDateClick,
      headerToolbar: false, // 기본 툴바 비활성화 (커스텀 사용)
      dayHeaderContent: function (args) {
        return DAY_NAMES[args.date.getDay()];
      },
      events: fetchReservationData,
      eventContent: renderEventContent,
      datesSet: handleDatesSet,
      loading: handleLoading,
    });

    calendarInstance.render();
    // [추가] 초기 데이터 로드 및 화면 이동
    var now = new Date();
    loadMonthData(now.getFullYear(), (now.getMonth()+1), function(result) {
      if (result.data && result.data.length > 0) {
        calendarInstance.gotoDate(result.data[0].date);
        updateCalendarTitle();

        setTimeout(function() {
          var $list = $('.calendar-date-list');
          var calendarEl = calendarInstance.el;
          var data = result.data;

          var uniqueDates = [...new Set(data.map(item => item.date))];

          uniqueDates.forEach(function(dateStr) {
            // 이미 선택된 목록에 없다면 실행
            if (selectedDates.indexOf(dateStr) === -1) {
              // 달력에서 해당 날짜의 엘리먼트(td) 찾기
              var dayEl = $(calendarEl).find('td[data-date="' + dateStr + '"]')[0];

              selectDate(dateStr, dayEl, $list);

              // 수정 모드이므로 reservedSlots에 서버 데이터 채우기
              if (!reservedSlots[dateStr]) reservedSlots[dateStr] = {};

              data.filter(d => d.date === dateStr).forEach(d => {
                var pc = d.pcNo;
                if (!reservedSlots[dateStr][pc]) reservedSlots[dateStr][pc] = [];

                //reservedSlots[dateStr][pc].push(d.start);

                var sHour = parseInt(d.start.split(':')[0]);
                var eHour = parseInt(d.end.split(':')[0]);

                for (var h = sHour; h < eHour; h++) {
                  var timeStr = h.toString().padStart(2, '0') + ':00';
                  if (reservedSlots[dateStr][pc].indexOf(timeStr) === -1) {
                    reservedSlots[dateStr][pc].push(timeStr);
                  }
                }
              });

            }
          });

          applyRangeStyling();
          $list.find('.calendar-date-item').first().trigger('click');
        }, 200);

      }
    });

    setupCustomNavigation();
    setupEventHandlers();
  }

  // ========================================
  // 네비게이션
  // ========================================

  /**
   * 커스텀 네비게이션 버튼 설정
   */
  function setupCustomNavigation() {
    var calendarEl = calendarInstance.el;
    var toolbar = document.createElement('div');
    toolbar.className = 'fc-toolbar fc-header-toolbar';
    toolbar.innerHTML = `
      <div class="fc-toolbar-chunk"></div>
      <div class="fc-toolbar-chunk">
        <button type="button" class="fc-prev-button fc-button fc-button-primary" aria-label="prev">
          <span class="fc-icon fc-icon-chevron-left"></span>
        </button>
        <h2 class="fc-toolbar-title"></h2>
        <button type="button" class="fc-next-button fc-button fc-button-primary" aria-label="next">
          <span class="fc-icon fc-icon-chevron-right"></span>
        </button>
      </div>
      <div class="fc-toolbar-chunk"></div>
    `;

    var viewHarness = calendarEl.querySelector('.fc-view-harness');
    if (viewHarness && viewHarness.parentNode) {
      viewHarness.parentNode.insertBefore(toolbar, viewHarness);
    }

    updateCalendarTitle();

    var prevBtn = toolbar.querySelector('.fc-prev-button');
    var nextBtn = toolbar.querySelector('.fc-next-button');

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (!isLoading) {
          navigateMonth('prev');
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (!isLoading) {
          navigateMonth('next');
        }
      });
    }

    //checkPrevButtonState();
  }

  /**
   * 월별 예약 데이터 로드 (공통 함수)
   * @TODO: 백엔드 API 엔드포인트로 변경 필요
   */
  function loadMonthData(year, month, onSuccess, onError) {
    if(!options || !options.url){
      reservationData = [];
      if (onSuccess) onSuccess({data : []}); // 빈 데이터 객체 전달
      return;
    }
    //var url = '/data/pcReservationData.json?year=' + year + '&month=' + month;

    $.ajax({
      url: options.url,
      method: 'POST',
      data : options.data,
      dataType: 'json',
      success: function (result) {
        reservationData = processReservationData(result.data || []);
        if (onSuccess) onSuccess(result);
      },
      error: function (xhr, status, error) {
        console.error('Failed to load reservation data:', error);
        reservationData = [];
        if (onError) onError(error);
      },
    });
  }

  /**
   * 서버 데이터를 UI 구조에 맞게 가공
   */
  function processReservationData(data) {
    var groupedByDate = {};

    data.forEach(function(item) {
      var d = item.date;
      if (!groupedByDate[d]) {
        groupedByDate[d] = {
          start: d,
          pcs: options.pcList.map(function(pc) {
            return {
              pcNo: pc.anlsPcNo,
              name: pc.anlsPcNm,
              reserved: []
            };
          })
        };
      }

      var pcEntry = groupedByDate[d].pcs.find(function(p) {
        return String(p.pcNo) === String(item.pcNo);
      });

      if (pcEntry && item.start && item.end) {
        pcEntry.reserved.push({
          start: item.start,
          end: item.end
        });
      }
    });

    return Object.values(groupedByDate);
  }



  /**
   * 데이터 프리로딩과 함께 이전/다음 월로 이동
   */
  function navigateMonth(direction) {
    if (isLoading) return;

    var currentDate = calendarInstance.getDate();
    var targetDate = new Date(currentDate);

    if (direction === 'prev') {
      targetDate.setMonth(targetDate.getMonth() - 1);
    } else {
      targetDate.setMonth(targetDate.getMonth() + 1);
    }

    isLoading = true;
    Utils.startLoading();
    disableNavigationButtons();

    var year = targetDate.getFullYear();
    var month = (targetDate.getMonth() + 1).toString().padStart(2, '0');

    loadMonthData(
      year,
      month,
      function () {
        calendarInstance.gotoDate(targetDate);
        isLoading = false;
        Utils.endLoading();
        enableNavigationButtons();
        updateCalendarTitle();
        //checkPrevButtonState();
      },
      function () {
        calendarInstance.gotoDate(targetDate);
        isLoading = false;
        Utils.endLoading();
        enableNavigationButtons();
        updateCalendarTitle();
        //checkPrevButtonState();
      },
    );
  }

  /**
   * 캘린더 타이틀 업데이트
   */
  function updateCalendarTitle() {
    var titleEl = document.querySelector('.fc-toolbar-title');
    if (titleEl && calendarInstance) {
      var date = calendarInstance.getDate();
      var year = date.getFullYear();
      var month = (date.getMonth() + 1).toString().padStart(2, '0');
      titleEl.textContent = year + '-' + month;
    }
  }

  /**
   * 이전 버튼 상태 확인 및 업데이트
   */
  function checkPrevButtonState() {
    var prevBtn = document.querySelector('.fc-prev-button');
    if (prevBtn && calendarInstance) {
      var now = new Date();
      var currentMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
      var viewDate = calendarInstance.getDate();
      var viewMonthStart = new Date(viewDate.getFullYear(), viewDate.getMonth(), 1);
      prevBtn.disabled = viewMonthStart <= currentMonthStart;
    }
  }

  /**
   * 네비게이션 버튼 비활성화
   */
  function disableNavigationButtons() {
    var prevBtn = document.querySelector('.fc-prev-button');
    var nextBtn = document.querySelector('.fc-next-button');
    if (prevBtn) prevBtn.disabled = true;
    if (nextBtn) nextBtn.disabled = true;
  }

  /**
   * 네비게이션 버튼 활성화
   */
  function enableNavigationButtons() {
    var prevBtn = document.querySelector('.fc-prev-button');
    var nextBtn = document.querySelector('.fc-next-button');
    if (prevBtn) prevBtn.disabled = false;
    if (nextBtn) nextBtn.disabled = false;
  }

  /**
   * 로딩 상태 변경 처리
   */
  function handleLoading(isLoadingNow) {
    isLoading = isLoadingNow;

    var prevBtn = document.querySelector('.fc-prev-button');
    var nextBtn = document.querySelector('.fc-next-button');

    if (prevBtn) {
        prevBtn.disabled = isLoadingNow;
    }

    if (nextBtn) {
      nextBtn.disabled = isLoadingNow;
    }
  }

  // ========================================
  // 날짜 선택 및 관리
  // ========================================

  /**
   * 날짜 클릭 이벤트 처리
   */
  function handleDateClick(info) {
    var dateStr = info.dateStr;

    // 날짜 유효성 검사
    if (!isDateSelectable(dateStr)) {
      return;
    }

    var $list = $('.calendar-date-list');
    var existingIndex = selectedDates.indexOf(dateStr);

    if (existingIndex > -1) {
      // 선택 해제
      deselectDate(dateStr, info.dayEl, $list);
    } else {
      // 선택
      selectDate(dateStr, info.dayEl, $list);
    }

    applyRangeStyling();
  }

  /**
   * 날짜 선택 가능 여부 확인
   */
  function isDateSelectable(dateStr) {
    var clickedDate = new Date(dateStr);
    var today = new Date();
    today.setHours(0, 0, 0, 0);

    // 과거 날짜 체크
    if (clickedDate < today) {
      return false;
    }

    // 주말 체크
    var dayOfWeek = clickedDate.getDay();
    if (dayOfWeek === 0 || dayOfWeek === 6) {
      return false;
    }

    // 오늘 체크
    if(dateStr == today.toLocaleDateString('sv-SE')){
      return false;
    }

    // 데이터 존재 여부 확인
    var dayData = reservationData.find(function (item) {
      return item.start === dateStr;
    });

    if (!dayData) {
      return true;
    }

    // 예약 가능한 PC가 있는지 확인
   /* var hasAvailablePC = dayData.pcs.some(function (pc) {
      return !pc.reserved || pc.reserved.length < TOTAL_TIME_SLOTS;
    });*/
    if (dayData.pcs && dayData.pcs.length > 0) {
      return dayData.pcs.some(function (pc) {
        // 해당 날짜의 PC 중 하나라도 빈 시간 슬롯이 있다면 true
        return !pc.reserved || pc.reserved.length < TOTAL_TIME_SLOTS;
      });
    }

    //return hasAvailablePC;
    return true;
  }

  /**
   * 날짜 선택
   */
  function selectDate(dateStr, dayEl, $list) {
    selectedDates.push(dateStr);
    $(dayEl).addClass('is-selected');

    var newItem =
      '<li class="calendar-date-item" data-date="' + dateStr + '">' + dateStr + '<a href="javascript:void(0)" class="btn-remove">' + '<i class="material-icons-outlined">close</i>' + '</a>' + '</li>';
    $list.append(newItem);

    // 첫 번째 항목이거나 활성화된 항목이 없으면 활성화
    if ($list.find('.calendar-date-item.active').length === 0) {
      $list.find('.calendar-date-item').last().trigger('click');
    }
  }

  /**
   * 날짜 선택 해제
   */
  function deselectDate(dateStr, dayEl, $list) {
    selectedDates.splice(selectedDates.indexOf(dateStr), 1);
    var $existingItem = $list.find('.calendar-date-item[data-date="' + dateStr + '"]');
    var wasActive = $existingItem.hasClass('active');
    $existingItem.remove();
    $(dayEl).removeClass('is-selected');

    // 해당 날짜의 예약 데이터 삭제
    if (reservedSlots[dateStr]) {
      delete reservedSlots[dateStr];
    }

    // 활성화된 항목을 제거한 경우, 다른 항목 선택
    if (wasActive) {
      var $remaining = $list.find('.calendar-date-item');
      if ($remaining.length > 0) {
        $remaining.first().trigger('click');
      } else {
        updateTable(null);
      }
    }
  }

  /**
   * 선택된 날짜에 범위 스타일 적용
   */
  function applyRangeStyling() {
    var calendarEl = calendarInstance.el;
    var $dates = $(calendarEl).find('.is-selected');
    var dateTimes = [];

    $dates.each(function () {
      var date = $(this).attr('data-date');
      if (date) {
        dateTimes.push(new Date(date).getTime());
      }
    });

    $dates.each(function () {
      var $this = $(this);
      var date = $this.attr('data-date');
      if (!date) return;

      var time = new Date(date).getTime();
      var hasPrev = dateTimes.indexOf(time - ONE_DAY_MS) !== -1;
      var hasNext = dateTimes.indexOf(time + ONE_DAY_MS) !== -1;

      $this.removeClass('is-range is-range-start is-range-end');

      if (hasNext && !hasPrev) {
        $this.addClass('is-range-start');
      } else if (hasPrev && hasNext) {
        $this.addClass('is-range');
      } else if (hasPrev && !hasNext) {
        $this.addClass('is-range-end');
      }
    });
  }

  // ========================================
  // 데이터 로딩 및 렌더링
  // ========================================

  /**
   * 현재 월의 예약 데이터 가져오기 (FullCalendar 초기 로딩용)
   */
  function fetchReservationData(info, successCallback, failureCallback) {
    var startDate = info.start;
    var year = startDate.getFullYear();
    var month = (startDate.getMonth() + 1).toString().padStart(2, '0');

    Utils.startLoading();

    loadMonthData(
      year,
      month,
      function (result) {

        var events = reservationData.map(function (day) {
          return {
            start: day.start,
            extendedProps: {
              pcs: day.pcs,
            },
          };
        });

        Utils.endLoading();
        successCallback(events);
      },
      function (error) {
        Utils.endLoading();
        failureCallback(error);
      },
    );
  }

  /**
   * 이벤트 콘텐츠 렌더링 (PC 가용성 표시 점)
   */
  function renderEventContent(arg) {
    var pcs = arg.event.extendedProps.pcs || [];

    // 예약한 pc만 보이게 처리
    var reservedPcs = pcs.filter(function(pc){
      return pc.reserved && pc.reserved.length > 0;
    })

    // 예약된 pc 없으면 pass
    if(reservedPcs.length == 0){
      return {
        html : ''
      }
    }

    // 수정 가능 판단
    var isEditable = options.isEditable;
    var listHtml = "";

    if(isEditable){
      listHtml = '<ul class="reserve-list-dots">';
      reservedPcs.forEach(function(pc) {
        var isAvailable = !pc.reserved || pc.reserved.length < TOTAL_TIME_SLOTS;
        var activeClass = isAvailable ? ' active' : '';
        listHtml += `<li class="reserve-item${activeClass}"></li>`;
      });
      listHtml += '</ul>';
    } else {
      listHtml = '<ul class="reserve-list-bars">';
      reservedPcs.forEach(function(pc) {
        var startTime = pc.reserved[0].start;
        listHtml += `
                <li class="bar-item">
                    <span class="bar-time">${startTime}</span>
                    <span class="bar-text">${pc.name}</span>
                </li>`;
      });
      listHtml += '</ul>';
    }

    /*reservedPcs.forEach(function (pc) {
      var isAvailable = !pc.reserved || pc.reserved.length < TOTAL_TIME_SLOTS;
      var activeClass = isAvailable ? ' active' : '';
      listHtml += `<li class="reserve-item${activeClass}"></li>`;
    });*/

    return {
      html: listHtml,
    }
  }

  /**
   * 캘린더 월/뷰 변경 처리
   */
  function handleDatesSet(info) {
    var titleEl = document.querySelector('.fc-toolbar-title');
    var prevBtn = document.querySelector('.fc-prev-button');
    var date = info.view.currentStart;

    if (titleEl) {
      var year = date.getFullYear();
      var month = (date.getMonth() + 1).toString().padStart(2, '0');
      titleEl.textContent = year + '-' + month;
    }

    /*if (prevBtn) {
      var now = new Date();
      var currentMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
      prevBtn.disabled = date <= currentMonthStart;
    }*/

    restoreSelectedDates();
    markUnavailableDates();
  }

  /**
   * 월 변경 후 선택된 날짜 스타일 복원
   */
  function restoreSelectedDates() {
    if (!calendarInstance) return;

    setTimeout(function () {
      var calendarEl = calendarInstance.el;
      selectedDates.forEach(function (dateStr) {
        var $cell = $(calendarEl).find('td[data-date="' + dateStr + '"]');
        if ($cell.length) {
          $cell.addClass('is-selected');
        }
      });
      applyRangeStyling();
    }, 100);
  }

  /**
   * 데이터가 없거나 예약 가능한 시간이 없는 날짜를 비활성화 표시
   */
  function markUnavailableDates() {
    if (!calendarInstance) return;

    setTimeout(function () {
      var calendarEl = calendarInstance.el;
      var $allDates = $(calendarEl).find('.fc-daygrid-day');

      $allDates.each(function () {
        var $this = $(this);
        var dateStr = $this.attr('data-date');

        if (!dateStr) return;

        var clickedDate = new Date(dateStr);
        var today = new Date();
        today.setHours(0, 0, 0, 0);

        // 과거 날짜, 주말, 오늘은 이미 CSS로 처리됨
        if (clickedDate < today) return;

        var dayOfWeek = clickedDate.getDay();
        if (dayOfWeek === 0 || dayOfWeek === 6) return;

        if (dateStr == today.toLocaleDateString('sv-SE')) return;

        if(options.minDate && dateStr <= options.minDate){
          $this.addClass('fc-day-disabled');
          return;
        } else if(options.maxDate && dateStr > options.maxDate){
          $this.addClass('fc-day-disabled');
          return;
        }

        // 해당 날짜의 데이터 찾기
        var dayData = reservationData.find(function (item) {
          return item.start === dateStr;
        });

        if (!dayData) {
          $this.removeClass('fc-day-disabled');
        } else {
          // 예약 가능한 PC가 있는지 확인
          var hasAvailablePC = dayData.pcs.some(function (pc) {
            return !pc.reserved || pc.reserved.length < TOTAL_TIME_SLOTS;
          });

          if (!hasAvailablePC) {
            $this.addClass('fc-day-disabled');
          } else {
            $this.removeClass('fc-day-disabled');
          }
        }

      });
    }, 100);
  }

  // ========================================
  // 예약 테이블
  // ========================================

  /**
   * 선택된 날짜 기준으로 예약 테이블 업데이트
   */
  function updateTable(date) {
    var $tbody = $('#reserve-tbody');
    $tbody.empty();

    if (!date) {
      renderEmptyState($tbody);
      return;
    }

    var dayData = reservationData.find(function (d) {
      return d.start === date;
    });

    if (!dayData || !dayData.pcs) {
      //renderEmptyState($tbody);

      var defaultPcs = [];
      defaultPcs = options.pcList.map(function(pc, i) {
        return {
          name: pc.anlsPcNm || 'PC-' + (i + 1),
          pcNo: pc.anlsPcNo,
          reserved: []
        };
      });
      renderReservationTable($tbody, date, defaultPcs);
      return;
    }
    renderReservationTable($tbody, date, dayData.pcs);
  }

  /**
   * 빈 상태 렌더링
   */
  function renderEmptyState($tbody) {
    $tbody.html(`
      <tr>
        <td colspan="10">
          <div class="empty">
            <i class="material-icons-round" aria-hidden="true">info</i>
            <p>예약할 날짜를 선택해주세요.</p>
          </div>
        </td>
      </tr>
    `);
  }

  /**
   * 예약 테이블 렌더링
   */
  function renderReservationTable($tbody, date, pcs) {

    pcs.forEach(function (pc) {
      var $tr = $('<tr>');

      // PC 이름 셀
      $tr.append(`
        <td>
          <div class="pc-item">
            <span class="bullet-icon" aria-hidden="true"></span>
            <span class="pc-name">${pc.name}</span>
          </div>
        </td>
      `);

      // 시간대 셀
      TIME_SLOTS.forEach(function (time) {
        //var isReserved = pc.reserved && pc.reserved.indexOf(time) !== -1;
        var isReserved = pc.reserved && pc.reserved.some(function(range) {
          return time >= range.start && time < range.end;
        });
        var userReserved = isUserReserved(date, pc.pcNo, time);

        var btnClass = buildButtonClass(isReserved, userReserved, options.isEditable);

       /* var disabledAttr = isReserved ? ' disabled' : '';
        var tabindexAttr = isReserved ? ' tabindex="-1"' : '';*/

        var dataAttrs = ` data-date="${date}" data-pc="${pc.pcNo}" data-time="${time}"`;

        $tr.append(`
          <td>
            <a href="javascript:void(0)" class="${btnClass}"${dataAttrs}>
              <span class="sr-only">예약하기</span>
            </a>
          </td>
        `);
        /*$tr.append(`
          <td>
            <a href="javascript:void(0)" class="${btnClass}"${disabledAttr}${tabindexAttr}${dataAttrs}>
              <span class="sr-only">예약하기</span>
            </a>
          </td>
        `);*/
      });

      $tbody.append($tr);
    });

    $tbody.find('.btn-reserve.active').each(function() {
      var $activeBtn = $(this);
      var columnIndex = $activeBtn.parent().index();
      var $table = $tbody.closest('table');

      toggleColumnButtons($table, columnIndex, $activeBtn);
    });
  }

  /**
   * 사용자가 예약한 슬롯인지 확인
   */
  function isUserReserved(date, pcNo, time) {
    return reservedSlots[date] && reservedSlots[date][pcNo] && reservedSlots[date][pcNo].indexOf(time) !== -1;
  }

  /**
   * 버튼 클래스 생성
   */
  function buildButtonClass(isReserved, userReserved, isEditable) {
    var classes = ['btn-reserve'];
    if(isEditable){
      if (userReserved || isReserved) {
        classes.push('active');
      }
    } else {
      if (isReserved) classes.push('is-used');
      if (userReserved) classes.push('active');
    }
    return classes.join(' ');
  }

  // ========================================
  // 이벤트 핸들러
  // ========================================

  /**
   * 이벤트 핸들러 설정
   */
  function setupEventHandlers() {
    setupDateListHandlers();
    setupReservationButtonHandlers();
  }

  /**
   * 날짜 리스트 핸들러 설정
   */
  function setupDateListHandlers() {
    // 날짜 리스트 항목 클릭
    $(document).on('click', '.calendar-date-item', function () {
      $(this).addClass('active').siblings().removeClass('active');
      var date = $(this).data('date') || $(this).text().trim();
      updateTable(date);
    });

    // 날짜 제거 버튼 클릭
    $(document).on('click', '.calendar-date-item .btn-remove', function (e) {
      e.stopPropagation();
      var $item = $(this).closest('.calendar-date-item');
      var date = $item.data('date') || $item.text().trim();
      var wasActive = $item.hasClass('active');

      // selectedDates 배열에서 제거
      var index = selectedDates.indexOf(date);
      if (index > -1) {
        selectedDates.splice(index, 1);
      }

      $item.remove();

      // 해당 날짜의 예약 데이터 삭제
      if (reservedSlots[date]) {
        delete reservedSlots[date];
      }

      // 캘린더에서 선택 해제
      if (calendarInstance) {
        var $cell = $(calendarInstance.el).find('td[data-date="' + date + '"]');
        if ($cell.length) {
          $cell.removeClass('is-selected');
          applyRangeStyling();
        }
      }

      // 활성 항목이었다면 다른 항목 선택
      if (wasActive) {
        var $remaining = $('.calendar-date-list .calendar-date-item');
        if ($remaining.length > 0) {
          $remaining.first().trigger('click');
        } else {
          updateTable(null);
        }
      }
    });
  }

  /**
   * 예약 버튼 핸들러 설정
   */
  function setupReservationButtonHandlers() {
    $(document).on('click', '.btn-reserve:not([disabled])', function () {
      var $this = $(this);
      var $td = $this.parent();
      var index = $td.index();
      var $table = $this.closest('table');

      var date = $this.data('date');
      var pc = $this.data('pc');
      var time = $this.data('time');

      if (!$this.attr('disabled')) {
        $this.toggleClass('active');
        updateReservedSlots(date, pc, time, $this.hasClass('active'));
      }

      // 같은 열의 다른 버튼들 비활성화/활성화
      toggleColumnButtons($table, index, $this);
    });
  }

  /**
   * 예약 슬롯 업데이트
   */
  function updateReservedSlots(date, pc, time, isActive) {
    if (isActive) {
      // 예약 추가
      if (!reservedSlots[date]) {
        reservedSlots[date] = {};
      }
      if (!reservedSlots[date][pc]) {
        reservedSlots[date][pc] = [];
      }
      reservedSlots[date][pc].push(time);
    } else {
      // 예약 제거
      if (reservedSlots[date] && reservedSlots[date][pc]) {
        var timeIndex = reservedSlots[date][pc].indexOf(time);
        if (timeIndex > -1) {
          reservedSlots[date][pc].splice(timeIndex, 1);
        }
        // PC의 예약이 모두 제거되면 PC 키 삭제
        if (reservedSlots[date][pc].length === 0) {
          delete reservedSlots[date][pc];
        }
      }
    }
  }

  /**
   * 같은 열의 버튼들 토글
   */
  function toggleColumnButtons($table, columnIndex, $currentButton) {
    var $colButtons = $table
      .find('tr')
      .find('td:eq(' + columnIndex + ') .btn-reserve')
      .not($currentButton);

    if ($currentButton.hasClass('active')) {
      $colButtons.attr('disabled', true);
      $colButtons.attr('tabindex', '-1');
    } else {
      $colButtons.removeAttr('disabled');
      $colButtons.removeAttr('tabindex');
    }
  }

  // ========================================
  // 공개 API
  // ========================================

  /**
   * 예약 데이터를 JSON 객체로 반환
   * @returns {Object} 선택된 날짜와 예약 슬롯 정보
   */
  function getReservationData() {
    var result = {
      selectedDates: selectedDates,
      reservations: [],
    };

    Object.keys(reservedSlots).forEach(function (date) {
      Object.keys(reservedSlots[date]).forEach(function (pc) {
        var times = reservedSlots[date][pc];
        var hours = times.map(t => parseInt(t.split(':')[0])).sort((a, b) => a - b);
        var startHour = hours[0];
        var endHour = hours[hours.length - 1] + 1;

        result.reservations.push({
          date: date,
          pc: pc,
          start: startHour.toString().padStart(2, '0') + ':00',
          end: endHour.toString().padStart(2, '0') + ':00'
        });
      });
    });

    return result;
  }

  /**
   * 예약 데이터를 JSON 문자열로 반환
   * @returns {string} JSON 문자열 형태의 예약 데이터
   */
  function getReservationJSON() {
    return JSON.stringify(getReservationData(), null, 2);
  }

  // 공개 API
  window.PCReservationCalendar = {
    init: initCalendar,
    getReservationData: getReservationData,
    getReservationJSON: getReservationJSON,
  };
})();
